import { TOGGLE_FEEDBACK_BUTTON } from './';

export const toggleFeedbackButton = (payload?: boolean) => {
  return {
    type: TOGGLE_FEEDBACK_BUTTON,
    payload,
  };
};
